import { render, staticRenderFns } from "./PlatformsPage.vue?vue&type=template&id=0c6da0a1&scoped=true"
import script from "./PlatformsPage.vue?vue&type=script&lang=js"
export * from "./PlatformsPage.vue?vue&type=script&lang=js"
import style0 from "./PlatformsPage.vue?vue&type=style&index=0&id=0c6da0a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6da0a1",
  null
  
)

export default component.exports